const Footer = () => {
    return (
        <footer>
            Created by Midian Judah at Juno College 2022
            </footer>
    )
}

export default Footer;